module.exports = __webpack_public_path__ + "img/blue_161.7b4e6485.png";